import { __decorate } from "tslib";
import Component from 'vue-class-component';
import ReactiveComponent from '../components/ReactiveComponent';
import Task from '@/services/task';
import TemplateContent from "@/components/template/TemplateContent.vue";
import VideoForm from "@/components/VideoForm.vue";
let VideoAdd = class VideoAdd extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.name = '';
        this.link = '';
        this.nameInvalid = false;
        this.linkInvalid = false;
        this.submitTask = Task.idle();
    }
    submit() {
        const videosListQuery = require('@/apollo/queries/videosList.graphql');
        this.subscribeMutation({
            tag: 'submit',
            options: {
                mutation: require('@/apollo/mutations/addVideo.graphql'),
                variables: {
                    name: this.name,
                    link: this.link,
                },
                update: (store, { data }) => {
                    try {
                        const videosListData = store.readQuery({ query: videosListQuery });
                        videosListData.videos.push(data.insert_videos.returning[0]);
                        store.writeQuery({ query: videosListQuery, data: videosListData });
                    }
                    catch (e) {
                        console.log('Failed to update cache after insert_videos mutation');
                        console.log(e);
                    }
                },
            },
            onTask: task => {
                this.submitTask = task;
                if (task.isSuccessful) {
                    this.$router.push({ name: 'videos_list' });
                }
            },
        });
    }
};
VideoAdd = __decorate([
    Component({
        components: { VideoForm, TemplateContent }
    })
], VideoAdd);
export default VideoAdd;
